import React, { createContext, useEffect, useState } from "react";
import { useVayuLead } from "./store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { Col, Row } from "react-bootstrap";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import ShowWayuLead from "./ShowWayuLead";
import { Tag } from "antd";
import LeadFilter from "./LeadFIlter";
import PlaceHolderActionable from "modules/dashboards/actionables/PlaceHolderActionable";
import NoData from "assets/svgs/no_data/NoData";
export const LeadData = createContext(null);

function VayuLead() {
  const { vayuLeadData, leadLoading, fetchVayuLead } = useVayuLead();
  const [page, setPage] = useState(1);
  const [doc, setDoc] = useState([]);
  const [query, setQuery] = useState(null);
  const [sendQuery, setSendQuery] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    fetchVayuLead(page, sendQuery);
  }, [page, sendQuery]);

  useEffect(() => {
    generateQuery();
  }, [query]);

  const generateQuery = () => {
    let buildQuery = [];
    if (startDate) {
      let data = `startDate=${moment(startDate).format("YYYY-MM-DD")}`;
      buildQuery.push(data);
    }

    if (endDate) {
      let data = `endDate=${moment(query?.endDate).format("YYYY-MM-DD")}`;
      buildQuery.push(data);
    }

    if (query?.gender) {
      const data = `gender=${query?.gender}`;
      buildQuery.push(data);
    }
    if (query?.formStatus) {
      const data = `formStatus=${query?.formStatus}`;
      buildQuery.push(data);
    }
    if (buildQuery.length > 0) {
      let filter = buildQuery.join("&");
      filter = "&" + filter;
      setSendQuery(filter);
    } else {
      setSendQuery("");
    }
  };

  useEffect(() => {
    if (vayuLeadData?.data?.length) {
      setDoc(vayuLeadData?.data?.[0]);
    }
  }, [vayuLeadData]);

  const propsData = {
    doc: doc,
    leadLoading: leadLoading,
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <div>Vayu Leads</div>
          <div>
            <LeadFilter
              query={query}
              setQuery={setQuery}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>
        </div>
      }
      component={
        <div>
          <Row>
            <Col
              md={2}
              className="scrollable-container"
              style={{
                height: "78vh",
                width: "40%",
                transition: "width 0.3s ease, opacity 0.3s ease",
                overflowY: "hidden",
              }}
            >
              <Row
                className="border rounded-2 rounded-top table-head py-3 mx-2"
                style={{ fontWeight: "600", fontFamily: "poppins" }}
              >
                <Col md={3} className="d-flex gap-2">
                  <span>Name</span>
                </Col>
                <Col md={2} className="text-center">
                  Form Filled
                </Col>
                <Col md={3}>Last Form Filled Status</Col>
                <Col md={4} className="text-center">
                  Last form fill date
                </Col>
              </Row>
              <div
                style={{ height: "60vh", overflowY: "scroll" }}
                className="scrollable-container"
              >
                {leadLoading ? (
                  <PlaceHolderActionable />
                ) : vayuLeadData?.data?.length ? (
                  vayuLeadData?.data?.map((lead, index) => {
                    return (
                      <Row
                        className={`border border-top-0 table-row ${
                          index === vayuLeadData?.data?.length - 1 &&
                          `rounded-bottom`
                        } py-2 ms-2 me-1`}
                      >
                        <Col md={3} className=" px-2">
                          <div className="d-flex ">
                            <span
                              className="cursor-pointer text-capitalize text-primary fw-bold fs-1"
                              onClick={() => {
                                setDoc(lead);
                              }}
                            >
                              {lead?.user?.[0]?.first_name}
                            </span>
                          </div>
                          <div className="w-100 fw-bold ">
                            {lead?.user?.[0]?.primary_phone_number_country_code}
                            {lead?.user?.[0]?.primary_phone_number}
                          </div>
                        </Col>
                        <Col md={2} className="text-center">
                          <div className="text-capitalize">
                            {lead?.form_filled ? (
                              <Tag className="text-uppercase" color="green">
                                Yes
                              </Tag>
                            ) : (
                              <Tag className="text-uppercase" color="volcano">
                                No
                              </Tag>
                            )}
                          </div>
                        </Col>
                        <Col md={3} className="text-center">
                          <div className="text-capitalize">
                            <Tag className="text-uppercase fs-1" color="blue">
                              {lead.last_form_fill_status}
                            </Tag>
                          </div>
                        </Col>
                        <Col md={4} className="text-center">
                          <div style={{ fontSize: "12px" }}>
                            {moment(lead.last_form_fill_date).format(
                              "DD MMM YYYY, hh:mm a"
                            )}
                          </div>
                        </Col>
                      </Row>
                    );
                  })
                ) : (
                  <div className="text-center mx-2 border py-2">
                    Data is not Available <NoData />
                  </div>
                )}
              </div>
              <Row>
                <PaginationDiv
                  paginationData={{
                    pageCount: vayuLeadData?.pagination?.pageCount || 1,
                    page: page,
                  }}
                  newPage={setPage}
                  activePage={page}
                />
              </Row>
            </Col>
            <Col
              className="p-0 mt-n3"
              style={{
                height: "80vh",
                transition: "width 0.3s ease",
                overflow: "hidden",
              }}
            >
              <LeadData.Provider value={propsData}>
                {vayuLeadData?.data?.length && <ShowWayuLead />}
              </LeadData.Provider>
            </Col>
          </Row>
        </div>
      }
    />
  );
}

export default VayuLead;
